<ngx-loading [show]="loading"></ngx-loading>
<div class="d-flex align-items-center justify-content-between teal-background white-font header">
  <span class="mr-auto">SERVICES</span>
</div>
<kendo-grid #grid="kendoGrid" [data]="gridView" (edit)="editHandler($event)">
  <kendo-grid-column field="available" title="Available" [width]="90">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div style="text-align: center; width: 100%">
        <label class="switch">
          <input
            type="checkbox"
            name="available"
            aria-label="Available for online booking"
            id="available"
            [checked]="dataItem.allowOnlineBooking"
            (change)="updateServiceAvailable(dataItem, $event)"
          />
          <span [ngStyle]="{ 'pointer-events': 'none' }" class="slider round"></span>
        </label>
      </div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="serviceName" title="Name"> </kendo-grid-column>
  <kendo-grid-column field="onlineServiceName" title="Online Name"> </kendo-grid-column>
  <kendo-grid-column field="bookingServiceCategoryId" title="Category">
    <ng-template kendoGridCellTemplate let-dataItem
      >{{ getCategoryName(dataItem.bookingServiceCategoryId) }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="onlineBookingDescription" title="Description"> </kendo-grid-column>
  <kendo-grid-column field="prerequisiteNames" title="Prerequisite"> </kendo-grid-column>
  <kendo-grid-column field="onlineBookingDurationMinutes" title="Online Duration" [width]="130"> </kendo-grid-column>
  <kendo-grid-column field="onlineprice" title="Online Price" [width]="115">
    <ng-template kendoGridCellTemplate let-dataItem>{{ dataItem.onlineBookingPrice | currency }} </ng-template>
  </kendo-grid-column>
  <kendo-grid-command-column title="Actions" [width]="90">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand class="btn kendo-btn"><i class="fas fa-edit"></i></button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
